/**
 * @copyright WaterStreet. All rights reserved.
 */

/* eslint-disable max-len */

import {
	HttpClient
} from '@angular/common/http';
import {
	Inject,
	Injectable
} from '@angular/core';
import {
	ISecurityAccessPolicyDefinitionDto
} from '@api/interfaces/security/security-access-policy-definition.dto.interface';
import {
	BaseEntityApiService
} from '@api/services/base/base-entity.api.service';
import {
	AppConstants
} from '@shared/constants/app.constants';
import {
	CacheService
} from '@shared/services/cache.service';

/* eslint-enable max-len */

/**
 * A class representing the logic and services of the security
 * access policy definition controller.
 *
 * @export
 * @class SecurityAccessPolicyDefinitionApiService
 * @extends {BaseEntityApiService<ISecurityAccessPolicyDefinitionDto>}
 */
@Injectable()
export class SecurityAccessPolicyDefinitionApiService
	extends BaseEntityApiService<ISecurityAccessPolicyDefinitionDto>
{
	/**
	 * Creates an instance of a SecurityAccessPolicyDefinitionApiService.
	 *
	 * @param {HttpClient} HttpClient
	 * The injected http client to use in the base api service.
	 * @param {CacheService} cache
	 * The injected cache service to use in the base api service.
	 * @memberof SecurityAccessPolicyDefinitionApiService
	 */
	public constructor(
		@Inject(HttpClient) http: HttpClient,
		@Inject(CacheService) cache: CacheService)
	{
		super();
		this.httpClient = http;
		this.cacheService = cache;
		this.endpoint =
			AppConstants.apiControllers.securityAccessPolicyDefinitions;
	}
}